<template>
    <div class="golf-player" 
        :class="{ 'element-shake': shake }"
        @click="select">
        <template v-if="!!person.personId">
            <div class="availibility-icon reserved"></div>
            <div class="golf-player-name">{{ person.firstName }} {{ person.familyName }}</div>
            <div class="golf-player-details">
                <div class="golf-player-club">{{ person.clubAbbreviation }}</div>
                <div class="golf-player-handicap">{{ $_formatCurrency(person.handicapActive, true, 1) }}</div>
                <template v-if="mode === 'normal'">
                    <div class="golf-player-price" style="min-width: 40px;text-align:right;">
                        <span v-if="!!price">{{ $_formatCurrency(price) }} {{ $_CURRENCY_SYMBOL }}</span>
                    </div>
                </template>
                <template v-if="mode === 'remove'">
                    <button class="btn btn-xs btn-danger" @click="$emit('select')">
                        <i class="glyphicon glyphicon-trash" v-if="!selected"></i>
                        <i class="glyphicon glyphicon-remove" v-if="selected"></i>
                    </button>
                </template>
                <template v-if="mode === 'add'">
                    <button class="btn btn-xs btn-success" @click="$emit('select')">
                        <i class="glyphicon glyphicon-plus" v-if="!selected"></i>
                        <i class="glyphicon glyphicon-remove" v-if="selected"></i>
                    </button>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        person: {
            type: Object,
            required: false,
            default: () => {},
        },
        price: {
            type: Number,
            required: false,
            default: null
        },
        mode: {
            type: String,
            required: false,
            default: 'normal'
        },
        selected: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => ({
        shake: false,
    }),
    methods: {
        select() {
            if (this.mode === 'normal') {
                this.$emit('select');
            }
        },
        isSelected() {
            return this.selected;
        },
        shakeElement() {
            this.shake = true;

            setTimeout(() => this.shake = false, 1000);
        }
    }
}
</script>